import { GraphQLClient } from 'graphql-request';

import {
  ctrackErrors,
  trackErrorEvent
} from 'src/utils/analytics/newrelic/RUMHelper';
import { GQL_FAILED_ERROR } from 'src/utils/constants/stringConstants';

import { getGraphQlClient } from './GraphQLClient';

export const graphQlRequest = async (
  query: string,
  requestObj: object,
  queryCode: string,
  headers?: string[]
): Promise<any> => {
  try {
    const client: GraphQLClient = getGraphQlClient(
      requestObj,
      queryCode,
      query,
      headers
    );
    const response: any = await client.request(query, {
      ...requestObj
    });
    if (response?.errors) {
      trackGqlError(queryCode, requestObj, response.errors);
    }
    return response;
  } catch (error) {
    console.error(
      'Something went wrong while fetching: ',
      queryCode,
      'graphQL request: ',
      JSON.parse(JSON.stringify(error))
    );
    ctrackErrors(error);
  }
};

// check and track GQL query error
const trackGqlError = (
  queryCode: string | undefined,
  variables: object,
  errors: [any]
) => {
  const [error] = errors;
  const errorDetails = {
    eventName: GQL_FAILED_ERROR,
    queryCode,
    path: error?.path,
    responseStatus: error?.extensions?.code,
    requestBody: variables,
    responseData: error?.extensions?.error,
    isGql: true
  } as any;
  trackErrorEvent(errorDetails);
};
